export default {
	data() {
		return {
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [25, 50, 100],
				total: 0
			}
		}
	},
	computed: {
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		}
	},
}
